<template>
  <div class="content_extra">
    <div class="item_extra">
      <div class="item_title">修改密码</div>
      <div class="item_content">
        <el-form ref="form" :rules="rules" :model="chanForm" label-width="180px">
          <el-form-item label="当前账号">
            <el-input v-model="username" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="输入旧密码">
            <el-input type="password" v-model="chanForm.password"></el-input>
          </el-form-item>
          <el-form-item prop="newPassword" label="输入新密码">
            <el-input type="password" v-model="chanForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item prop="rePassword" label="确认新密码">
            <el-input type="password" v-model="chanForm.rePassword"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: "Chanpass",
  data () {

    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.chanForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      username: this.$store.state.user_info.username,
      chanForm: {
        password: '',
        newPassword: '',
        rePassword: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations(['setLogout']),
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.http.fetchPost(this.api.user_changepass, this.chanForm).then((res) => {
            var data = res.data;
            console.log(data);
            if (data.code === 200) {
              this.$message.success('修改成功，请使用新密码重新登录');
              // 清除登录状态
              this.setLogout();
              // 延迟跳转到登录页面，让用户看到成功提示
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            } else {
              this.$message.error(data.message);
            }
          }).catch(err => {
            console.log(err)
            this.$message.error('修改密码失败，请重试');
          })
        } else {
          // this.$message.error('请输入必填信息');
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted () {
    console.log(this.$store.state.user_info)
  }
}
</script>

<style scoped lang="stylus">
.content_extra {
  /* background-color red */
  /* text-align:center */
  /* justify-content:center; */
  /* display: -webkit-flex; */
  .item_extra {
    display: block;

    .item_content {
      padding-left: 150px;
      width: 500px;
    }

    .item_title {
      height: 60px;
      line-height: 60px;
      background-color: #eeeeee;
      margin-bottom: 10px;
      padding-left: 20px;
    }

    /* text-align left */
    /* display:inline-block */
  }

  /* margin 0 50px */
}
</style>
